import { createApiInstance } from './config'

// 使用统一的API实例
const api = createApiInstance()

/**
 * 查询窗口日志
 * @param {string} windowId 窗口ID
 * @param {number} page 页码（从1开始）
 * @param {number} size 每页大小
 * @returns {Promise} 日志数据
 */
export function getWindowLogs(windowId, page = 1, size = 50, fromTime = null, toTime = null) {
  const params = {
    windowId,
    page,
    size
  }
  
  if (fromTime) params.fromTime = fromTime
  if (toTime) params.toTime = toTime
  
  return api.get('/logs/window', {
    params
  })
}

/**
 * 查询钻石走势
 * @param {string} windowId 窗口ID
 * @param {number} weeks 查询周数（1-4周）
 * @returns {Promise} 钻石走势数据
 */
export function getDiamondTrend(windowId, weeks = 1) {
  return api.get('/logs/diamond-trend', {
    params: {
      windowId,
      weeks
    }
  })
}
